// Reads a positive number of minutes from an env var, falling back to a default
function minutesFromEnv(value, fallback) {
  let minutes = parseFloat(value);
  return Number.isFinite(minutes) && minutes > 0 ? minutes : fallback;
}

let sessionTimeoutMinutes = minutesFromEnv(process.env.VUE_APP_SESSION_TIMEOUT_MINUTES, 30);
let sessionWarningMinutes = minutesFromEnv(process.env.VUE_APP_SESSION_WARNING_MINUTES, 10);
// The warning has to start after the user goes idle, so it can never cover the whole timeout
if (sessionWarningMinutes >= sessionTimeoutMinutes) {
  sessionWarningMinutes = sessionTimeoutMinutes / 2;
}

let config = {
  API_URL: process.env.VUE_APP_API_URL,
  APP_TITLE: "Vue Form Builder",
  // Idle session timeout (EB2-56029): total inactivity allowed before auto logout,
  // and how long before that the "Stay Logged In" warning is shown
  SESSION_TIMEOUT_MINUTES: sessionTimeoutMinutes,
  SESSION_WARNING_MINUTES: sessionWarningMinutes,
};

export default config;
